import styled from 'styled-components'
import { Text } from '../Text'

export const StyledBottomNavItem = styled.button<{ isActive: boolean }>`
  display: block;
  border: 0;
  background: transparent;
  cursor: pointer;
  height: 44px;
  padding: 4px 12px;
  border-radius: 6px;
  &:hover,
  &:hover div {
    color: white;
  }
`

export const StyledBottomNavText = styled(Text)`
  display: -webkit-box;
  overflow: hidden;
  user-select: none;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  -webkit-user-select: none;
  -webkit-touch-callout: none;
`
